module.exports = __webpack_public_path__ + "img/flags/BA.252eb01.png";